export const extractDomainName = (url?: string) => {
  const regex = /^(?:https?:\/\/)?(?:[^\n@]+@)?(?:www\.)?([^\n/:=?]+)/im
  const match = regex.exec(url ?? '')
  const domain = match ? match[1] : ''
  if (domain.length > 0) return domain
}
